const header = document.querySelector('.header');
const STICKY_THRESHOLD = 80;
const HIDE_THRESHOLD = 400;

let lastScrollY = window.scrollY;

function updateHeader(currentScrollY, isScrollingDown) {
    const isPastHideThreshold = currentScrollY > HIDE_THRESHOLD;
    header.classList.toggle('header--sticky', currentScrollY > STICKY_THRESHOLD);
    header.classList.toggle('header--hidden', isPastHideThreshold && isScrollingDown);
}

updateHeader(window.scrollY, false);

window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;
    const isScrollingDown = currentScrollY > lastScrollY;

    updateHeader(currentScrollY, isScrollingDown);

    lastScrollY = currentScrollY;
});
